import React from "react";

export const CATEGORIES = {
  "Panadería y pastelería": "1",
  "Aprende con nuestro portafolio": "2",
  "Nuestras recetas": "3",
  Levadura: "4",
  Premezclas: "5",
  Margarinas: "6",
  Cremas: "7",
  Complementos: "8",
  Seminarios: "9",
  "Expertos Fleischmann": "10",
  "Experiencia Express": "23",
  "Tips y Recomendaciones": "25",
};

const EXAMS = {
  Negocios: "1",
  "Cápsula Costo Fijos": "2",
  "Cápsula Punto de equilibrio": "7",
  "Salario propio": "14",
  "Trámites de empresa": "15",
};

export const urlToId = (uri) => {
  return CATEGORIES[uri];
};

export const ExamToId = (uri) => {
  return EXAMS[uri];
};
